/** AMENDED 2026-10-06 (plan-014 C3): the three organization-key scopes (design §27.5.4) are described too. */
export const SCOPE_DESCRIPTION = {
    "agent:read": "Read your agents and how they are set up.",
    "agent:write": "Create, change, publish and pause agents.",
    "conversation:read": "Read conversations and their transcripts.",
    "recording:read": "Play call recordings.",
    "campaign:write": "Read and change contact lists and outbound campaigns.",
    "credit:spend": "Read the balance, top up and spend credit.",
    "order:read": "Read orders from the order book.",
    "order:write": "Take, change and cancel orders.",
    "conversation:dial": "Start outbound conversations through your SIP trunk — billed talk time.",
    "billing:read": "Read your organization's balances and the offers it can buy (organization keys).",
    "usage:read": "Read your organization's usage, by workspace (organization keys).",
    "document:read": "Read and download your organization's invoices, receipts and statements (organization keys).",
};
//# sourceMappingURL=scope-description.js.map